// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.partner-container{
    padding: 3rem 1rem;
    margin-bottom: 1rem;
    margin-top: 5%;
    text-align: center;
}
.partners-card-parent{
    display: flex;
    justify-content: center;
    align-items:center;
    gap:2%;
    padding: 2rem 0;
    flex-wrap: wrap;
}
.partner-img{
    padding: 1rem;
    flex: 0 0 18%;
    height: 8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: 1px solid lightgray;
}
.partner-img:last-child{
    border-right: none;

}
.partner-img>img{
    width: 90%;
}
@media only screen and (max-width:800px){
    .partner-container{
        margin-top: 0%;
    }
}

@media only screen and (max-width:700px){
    .partners-card-parent{

        gap:5%;
        border-bottom: 0px solid lightgray;
        padding: 2rem 0;
    }
    .partner-img{
        padding: 1rem;
        flex: 0 0 10rem;
        border-right: 0px solid lightgray;
        border-bottom:1px solid lightgray ;
    }
}
@media only screen and (max-width:550px){
    .partner-container{
        margin-top: 3rem;
    }
}

@media only screen and (max-width:400px){
    .partners-card-parent{
        gap:5%;
        border-bottom: 0px solid lightgray;
        padding: 2rem 0;
    }
    .partner-img{
        padding: 1rem;
        flex: 0 0 8rem;
        border-right: 0px solid lightgray;
        border-bottom:1px solid lightgray ;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Partners/Partners.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,MAAM;IACN,eAAe;IACf,eAAe;AACnB;AACA;IACI,aAAa;IACb,aAAa;IACb,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iCAAiC;AACrC;AACA;IACI,kBAAkB;;AAEtB;AACA;IACI,UAAU;AACd;AACA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;;QAEI,MAAM;QACN,kCAAkC;QAClC,eAAe;IACnB;IACA;QACI,aAAa;QACb,eAAe;QACf,iCAAiC;QACjC,kCAAkC;IACtC;AACJ;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,MAAM;QACN,kCAAkC;QAClC,eAAe;IACnB;IACA;QACI,aAAa;QACb,cAAc;QACd,iCAAiC;QACjC,kCAAkC;IACtC;AACJ","sourcesContent":[".partner-container{\n    padding: 3rem 1rem;\n    margin-bottom: 1rem;\n    margin-top: 5%;\n    text-align: center;\n}\n.partners-card-parent{\n    display: flex;\n    justify-content: center;\n    align-items:center;\n    gap:2%;\n    padding: 2rem 0;\n    flex-wrap: wrap;\n}\n.partner-img{\n    padding: 1rem;\n    flex: 0 0 18%;\n    height: 8rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-right: 1px solid lightgray;\n}\n.partner-img:last-child{\n    border-right: none;\n\n}\n.partner-img>img{\n    width: 90%;\n}\n@media only screen and (max-width:800px){\n    .partner-container{\n        margin-top: 0%;\n    }\n}\n\n@media only screen and (max-width:700px){\n    .partners-card-parent{\n\n        gap:5%;\n        border-bottom: 0px solid lightgray;\n        padding: 2rem 0;\n    }\n    .partner-img{\n        padding: 1rem;\n        flex: 0 0 10rem;\n        border-right: 0px solid lightgray;\n        border-bottom:1px solid lightgray ;\n    }\n}\n@media only screen and (max-width:550px){\n    .partner-container{\n        margin-top: 3rem;\n    }\n}\n\n@media only screen and (max-width:400px){\n    .partners-card-parent{\n        gap:5%;\n        border-bottom: 0px solid lightgray;\n        padding: 2rem 0;\n    }\n    .partner-img{\n        padding: 1rem;\n        flex: 0 0 8rem;\n        border-right: 0px solid lightgray;\n        border-bottom:1px solid lightgray ;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
